import { useCallback, useState } from "react";
import { getApiErrorMessage } from "../../../lib/result-codes";
import { createUser as createUserApi } from "../api/users.api";
import type { UserCreateRequest, UserItem } from "../types/user.types";

export interface UseCreateUserReturn {
  createUser: (request: UserCreateRequest) => Promise<UserItem>;
  loading: boolean;
  error: string | null;
}

export function useCreateUser(): UseCreateUserReturn {
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState<string | null>(null);

  const create = useCallback(async (request: UserCreateRequest) => {
    setLoading(true);
    setError(null);
    try {
      return await createUserApi(request);
    } catch (requestError: unknown) {
      setError(getApiErrorMessage(requestError, "Failed to create user"));
      throw requestError;
    } finally {
      setLoading(false);
    }
  }, []);

  return { createUser: create, loading, error };
}
